import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"minus\">\n    <!-- Generator: Sketch 62 (91390) - https://sketch.com -->\n    <title>Icons/main/minus</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"minus_Icons/main/minus\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <rect id=\"minus_Rectangle\" x=\"0\" y=\"6\" width=\"14\" height=\"2\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol